import { useQuery } from "@tanstack/react-query";
// organization-service.js is plain JS, so this import is implicitly typed `any`.
import { organizationApi } from "../../../services/organization-service";
import { useMCPQueryScope, mcpRequestOptions } from "./useMCPQueryScope";
import { mcpQueryKeys } from "../query-keys";

export type Organization = {
  id: string;
  name?: string;
};

export const ORGANIZATIONS_QUERY_KEY = ["mcps-organizations"] as const;

type Options = {
  enabled?: boolean;
};

// GET /organizations/ — the authority on which org a connector shares into.
// The connector dialog fires this on every open so a stale or missing
// localStorage org id can't point the members lookup at the wrong org. Matches
// the members query's refetch policy: always on mount, deduped for 30s.
const REFETCH_WINDOW = 30 * 1000;

export const useOrganizations = ({ enabled = true }: Options = {}) => {
  const scope = useMCPQueryScope();
  return useQuery<Organization[]>({
    queryKey: [...mcpQueryKeys.scope(scope.key), "organizations"],
    enabled: enabled && scope.enabled,
    staleTime: REFETCH_WINDOW,
    refetchOnMount: "always",
    queryFn: async ({ signal }) => {
      const response = await organizationApi.getOrganizations(mcpRequestOptions(scope, signal));
      const orgs = response?.data ?? [];
      return Array.isArray(orgs) ? (orgs as Organization[]) : [];
    },
  });
};
